const Structure = ({ children }) => {
  return <div className="flex justify-center text-black">{children}</div>;
};
export default Structure;
